import { RecordData } from '../../helpers-classes';
import { PanelData, PanelsDataIn } from './types';

export const panelsData = (dataIn: PanelsDataIn = null): PanelsDataIn => {
	const rd = new RecordData<PanelsDataIn>(dataIn);

	const record: PanelsDataIn = {
		frontPanelId: rd.useNewOrDefault('frontPanelId', null),
		children: rd.useNewOrDefault<Array<PanelData>>('children', []),
		surroundMaterial: dataIn?.surroundMaterial ?? null
	};

	return record;
};
